import React from 'react'
import CreateAccount from '../../components/CreateAccount/CreateAccount'

const c = (props) => <CreateAccount location={props.location} />

export default c
